import { KOUTO_EMBED_ROOT } from 'consts';
import { EMBED_CONFIG_PROPERTIES_MAP } from 'features/EmbedConfig/helpers';

const getEmbeddedCategoryId = (): string | null => {
  const element = document.getElementById(KOUTO_EMBED_ROOT);
  return element?.getAttribute(EMBED_CONFIG_PROPERTIES_MAP.categoryId) || null;
};

export default getEmbeddedCategoryId;
